/* eslint-disable @typescript-eslint/no-explicit-any */
import { useClient } from '@composables/use-clients';
import { PostRequestArgsType } from '@api/v1/types';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type CurrentUserTenantInvitationCodeDeclineSerializerType = {
  invitationCode: string;
  tenant: Record<string, any>;
};

export type PostCurrentUserTenantInvitationCodeDeclinePayloadType = (
  Pick<CurrentUserTenantInvitationCodeDeclineSerializerType, 'invitationCode'>
);
export type PostCurrentUserTenantInvitationCodeDeclineResponseType = (
  Pick<CurrentUserTenantInvitationCodeDeclineSerializerType, 'tenant'>
);

export const apiDeclineTenantInvitationCode = async ({
  payload,
  errorConfig = {},
  callbacks = {},
}: PostRequestArgsType<PostCurrentUserTenantInvitationCodeDeclinePayloadType>) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.currentUserTenantInvitationCodeDecline(),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
